import React from "react";
import { useDispatch, useSelector } from "react-redux";
import debounce from "lodash.debounce";
import { SearchIcon, CloseIcon } from "../components/icons";
import { setFilterByContent } from "../ducks/searchSlice";

// A barra de categorias usa este id para trazer o foco de volta à busca.
export const MENU_SEARCH_INPUT_ID = "menu-search-input";

export default function BasicSearch() {
  const dispatch = useDispatch();
  const searchingContent = useSelector((state) => state.search.content);
  const [value, setValue] = React.useState(searchingContent);
  const debouncedDispatch = React.useRef(debounce(dispatch, 200));

  React.useEffect(() => {
    const pending = debouncedDispatch.current;
    return () => pending.cancel();
  }, []);

  // A busca também é limpa de fora (o "Limpar busca" do resultado vazio).
  // Só o vazio é sincronizado: copiar qualquer valor da store apagaria o que
  // o cliente digitou durante o debounce.
  React.useEffect(() => {
    if (searchingContent === "") setValue("");
  }, [searchingContent]);

  const handleChange = (event) => {
    const content = event.target.value;
    setValue(content);
    debouncedDispatch.current(setFilterByContent({ content }));
  };

  const clear = () => {
    setValue("");
    debouncedDispatch.current.cancel();
    dispatch(setFilterByContent({ content: "" }));
    document.getElementById(MENU_SEARCH_INPUT_ID)?.focus();
  };

  return (
    <form
      role="search"
      className="menu-search"
      onSubmit={(e) => {
        e.preventDefault();
        // "Buscar" no teclado do celular: fecha o teclado para mostrar o
        // resultado.
        document.getElementById(MENU_SEARCH_INPUT_ID)?.blur();
      }}
    >
      <SearchIcon className="menu-search__icon" aria-hidden="true" />
      <input
        id={MENU_SEARCH_INPUT_ID}
        type="search"
        inputMode="search"
        enterKeyHint="search"
        autoComplete="off"
        className="menu-search__input"
        placeholder="Buscar no cardápio"
        aria-label="Buscar no cardápio"
        value={value}
        onChange={handleChange}
      />
      {value && (
        <button
          type="button"
          className="icon-button menu-search__clear"
          onClick={clear}
          aria-label="Limpar busca"
        >
          <CloseIcon fontSize="small" />
        </button>
      )}
    </form>
  );
}
